import { Card, Icon } from 'semantic-ui-react';
import styles from './styles/Activity.module.scss';
import { useTranslation } from 'react-i18next';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import CommonTagsInputWrapper from '@components/common/CommonTagsInputWrapper';
import { filterActions } from '@behavior/filter';
import { useState } from 'react';
import ChemicalDetailsCard from './ChemicalDetailsCard';
import { renderSuggestionAddition } from './RenderSuggestionAddition';
import { useFormContext } from 'react-hook-form';
import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';

type Props = {
  prevChemicalProductId?: number | null;
  onRemove?: () => void;
  setChemicalProductIdList?: any;
  chemicalProductsList?: ActivityChemicalsDTO[];
  setChemicalProductsList?: (chemicalProductsList: ActivityChemicalsDTO[]) => void;
  cardKey?: number;
  activityId?: number;
};

const ChemicalCard = ({
  onRemove,
  prevChemicalProductId,
  setChemicalProductIdList,
  chemicalProductsList,
  setChemicalProductsList,
  cardKey,
  activityId,
}: Props) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const [chemicalProductId, setChemicalProductId] = useState<number | null>(
    prevChemicalProductId ?? null
  );

  const onChemicalProductChange = (selectedChemicalProduct: any) => {
    if (selectedChemicalProduct) {
      setChemicalProductId(selectedChemicalProduct.id);
      setChemicalProductIdList((prevList: any) => [...prevList, selectedChemicalProduct.id]);
    }
  };

  return (
    <Card className={styles.chemicalCard}>
      {chemicalProductId == null && (
        <div className={styles.basicDiv}>
          <div className={styles.flexContainerActivity}>
            <div className={styles.closeButton}>
              {cardKey !== 0 && <Icon name="close" size="small" color="blue" onClick={onRemove} />}
            </div>
          </div>
          <div className={styles.searchChemical}>
            <GridColumnInputWrapper
              {...register('chemicalProduct', {
                validate: value => {
                  if (!Array.isArray(value) || value.length < 1) {
                    return t('activity.form.error.chemical.product.required');
                  }
                  return true;
                },
              })}
              name="chemicalProduct.selectedChemicalProduct"
              label="chemical.product.details.page.chemical.container.search.trade.name.input"
              render={(props: any) => (
                <div className={styles.activityChemicalCard}>
                  <div className={styles.errorMessage}>
                    {errors?.chemicalProduct?.message?.toString()}
                  </div>
                  <CommonTagsInputWrapper
                    {...props}
                    value={null}
                    dynamicSuggestionListActionWithName={filterActions.getAutoCompleteSuggestionsList.bind(
                      this,
                      true
                    )}
                    dynamicSuggestionName="EXCLUDED_GEN_TRADE_CHEMICAL_NAMES"
                    matchProperty="id"
                    displayProps="tradeName,chemicalName"
                    maxTags={1}
                    disabled={false}
                    onSelect={onChemicalProductChange}
                    renderSuggestionAddition={(obj: any) => renderSuggestionAddition(obj, t)}
                  />
                </div>
              )}
            />
          </div>
        </div>
      )}
      {chemicalProductId != null && (
        <ChemicalDetailsCard
          activityId={activityId}
          key={chemicalProductId}
          onRemove={onRemove}
          chemicalProductId={chemicalProductId}
          chemicalProductsList={chemicalProductsList}
          setChemicalProductsList={setChemicalProductsList}
        />
      )}
    </Card>
  );
};

export default ChemicalCard;
